export const financial = (x: string | number, forInput: boolean = false) => {
  if (forInput) {
    return `${x}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  if (isNaN(Number(x)) || x === undefined) {
    console.error('financial: expexted number or string, but got ' + x);
    return 0;
  }
  x = '' + x;
  return Number.parseFloat(x).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const financialToNumber = (x: string) => {
  if (typeof x !== 'string') {
    console.error('financialToNumber: expexted string, but got ' + x);
    return null;
  }
  const newX = +(x.replace(/,/g, ''));
  if (isNaN(newX)) {
    console.error('financialToNumber: cannot convert ' + x + ' to number');
    return null;
  }
  return newX;
};

// 枚举货币
export const currencyEnum = {
  rmb: '人民币',
  usd: '美元',
  eur: '欧元',
  gbp: '英镑',
  jpy: '日元',
  hkd: '港币',
  twd: '新台币',
  krw: '韩元',
  myr: "林吉特",
  sgd: '新加坡元',
}
